import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { ValidWidths } from '@sorare/core/src/atoms/ui/ResponsiveImg';
import { Card } from '@sorare/core/src/components/card/Card';
import { OpenItemDialogLink } from '@sorare/core/src/components/link/OpenItemDialogLink';

import { useClickCardEvent } from '#src/hooks/events/useClickCardEvent.ts';

import type { FlexCard_anyCard } from './__generated__/index.graphql.ts';

type FlexCardProps = {
  card: FlexCard_anyCard;
  withLink?: boolean;
  width?: ValidWidths;
  onClick?: () => void;
};

export const FlexCard = (props: FlexCardProps) => {
  const { card, withLink, width, onClick } = props;
  const trackClickCard = useClickCardEvent();
  const style = width ? { maxWidth: width } : undefined;

  if (withLink)
    return (
      <OpenItemDialogLink
        className="relative block w-full bg-transparent"
        item={card}
        onClick={onClick || (() => trackClickCard(card, Boolean(card.user)))}
        sport={card.sport}
        style={style}
      >
        <Card card={card} width={width} />
      </OpenItemDialogLink>
    );
  return (
    <div className="relative block w-full bg-transparent" style={style}>
      <Card card={card} width={width} />
    </div>
  );
};

FlexCard.fragments = {
  anyCard: gql`
    fragment FlexCard_anyCard on AnyCardInterface {
      slug
      sport
      user {
        slug
      }
      ...Card_anyCard
      ...useClickCardEvent_anyCard
    }
    ${Card.fragments.anyCard}
    ${useClickCardEvent.fragments.anyCard}
  ` as TypedDocumentNode<FlexCard_anyCard>,
};
